import categoryMappings from './helpers/expert-category-mappings.json';

import { AdvizedTest } from '../../types';
import { MetaDataContext } from './types';

type Props = {
  data: {
    test: AdvizedTest;
  };
};

const expertTest = ({ data }: Props, { t, market }: MetaDataContext) => {
  if (!data) {
    return {};
  }

  const { test } = data;
  const { category } = data.test.product || {};

  if (!test) return {};

  const title =
    test.metaTitle?.replace('Advized.se', t('meta', 'site.name')) ||
    t('meta', 'expert.test-title', {
      title: test.product.name,
    });

  const description =
    test.metaDescription ||
    t('meta', 'expert.test-description', {
      category: category?.name
        ? `${categoryMappings.singularDeterminates[category?.name] ||
            category?.name.toLowerCase()} `
        : '',
      title: test.product.name,
    });

  const openGraph = [
    { key: 'url', content: test.fullUrl },
    { key: 'title', content: title },
    { key: 'description', content: description },
    { key: 'type', content: 'website' },
    { key: 'image', content: test.imageWithSize?.src },
    { key: 'siteName', content: t('meta', 'site.name') },
    { key: 'brand', content: test.product.advizedBrand },
    { key: 'priceAmount', content: test.product.priceSummary.regular },
    { key: 'priceCurrency', content: market.currency },
  ];

  const structuredData = {
    '@context': 'http://schema.org',
    '@type': 'Product',
    name: test.product.name,
    lowPrice: test.product.priceSummary.regular,
    images: [test.product.media.first],
    author: test.expert.name,
    datePublished: test.date,
    reviewName: test.title,
    reviewBody: test.suitedForLong,
    ratingValue: test.grade / 2,
  };

  return {
    description,
    title,
    canonical: test.fullUrl,
    openGraph,
    structuredData,
  };
};

export default expertTest;
